'use strict';
/*eslint no-unused-vars: 0, no-extra-parens: 0*/
import React from 'react';
import { render } from 'react-dom';
import { renderToString } from 'react-dom/server';
import { createBrowserHistory } from 'history';
import { BrowserRouter as Router, Route } from 'react-router-dom'

import AppContainer from './containers/AppContainer';

//TODO history back and forward

if (window === undefined) {
  //server side
  print(renderToString(<AppContainer />));
} else {
  //client side
  const history = createBrowserHistory({});
  let containerEl = document.querySelector('.app-container');
  if(containerEl) {
    render(
      <Router history={history}>
        <Route path={matrixData.urlHome} component={AppContainer} />
      </Router>,
      containerEl
    );
  }
}